﻿    (function () {
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

      function initReveal() {
        const targets = Array.from(document.querySelectorAll(".lm-reveal"));

        function revealHashTarget() {
          if (!window.location.hash) {
            return;
          }

          const target = document.querySelector(window.location.hash);

          if (!target) {
            return;
          }

          if (target.classList.contains("lm-reveal")) {
            target.classList.add("is-visible");
          }

          target.querySelectorAll(".lm-reveal").forEach((element) => {
            element.classList.add("is-visible");
          });
        }

        function revealPassedTargets() {
          targets.forEach((target) => {
            if (target.classList.contains("is-visible")) {
              return;
            }

            const isLateReveal = target.hasAttribute("data-reveal-late");
            const isTallViewport = window.innerHeight > window.innerWidth * 0.7;
            const revealPoint = isLateReveal ? (isTallViewport ? 0.76 : 0.56) : 0.92;

            if (target.getBoundingClientRect().top < window.innerHeight * revealPoint) {
              target.classList.add("is-visible");
            }
          });
        }

        if (!("IntersectionObserver" in window) || reducedMotion.matches) {
          targets.forEach((target) => target.classList.add("is-visible"));
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
              }
            });
          },
          {
            rootMargin: "0px 0px -12% 0px",
            threshold: 0.12
          }
        );

        const lateObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                lateObserver.unobserve(entry.target);
              }
            });
          },
          {
            rootMargin: "0px 0px -44% 0px",
            threshold: 0.12
          }
        );

        targets.forEach((target) => {
          if (target.hasAttribute("data-reveal-late")) {
            lateObserver.observe(target);
          } else {
            observer.observe(target);
          }
        });

        let revealRetryTimer;

        function queueRevealPassedTargets(delay = 120) {
          window.clearTimeout(revealRetryTimer);
          revealRetryTimer = window.setTimeout(revealPassedTargets, delay);
        }

        let revealScrollQueued = false;

        function queueRevealOnScroll() {
          if (revealScrollQueued) {
            return;
          }

          revealScrollQueued = true;
          window.requestAnimationFrame(function () {
            revealScrollQueued = false;
            revealPassedTargets();
          });
        }

        revealPassedTargets();
        revealHashTarget();
        queueRevealPassedTargets();
        window.setTimeout(revealHashTarget, 180);
        window.addEventListener("scroll", queueRevealOnScroll, { passive: true });
        window.addEventListener("resize", () => queueRevealPassedTargets(), { passive: true });
        window.addEventListener("orientationchange", () => queueRevealPassedTargets(180), { passive: true });
        window.addEventListener("hashchange", () => {
          window.setTimeout(revealPassedTargets, 80);
          window.setTimeout(revealHashTarget, 120);
        });
      }

      function initAnchorScroll() {
        const links = Array.from(document.querySelectorAll("a[href^='#']"));

        links.forEach((link) => {
          link.addEventListener("click", (event) => {
            const hash = link.getAttribute("href");

            if (!hash || hash === "#") {
              return;
            }

            const target = document.querySelector(hash);

            if (!target) {
              return;
            }

            event.preventDefault();
            const currentScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
            const targetTop = target.getBoundingClientRect().top + currentScrollY;

            if (window.location.hash !== hash) {
              window.history.pushState(null, "", hash);
            }

            const scrollingElement = document.scrollingElement || document.documentElement;
            const previousScrollBehavior = document.documentElement.style.scrollBehavior;

            document.documentElement.style.scrollBehavior = "auto";
            scrollingElement.scrollTop = targetTop;
            window.scrollTo(0, targetTop);
            document.documentElement.style.scrollBehavior = previousScrollBehavior;

            window.setTimeout(() => {
              target.querySelectorAll(".lm-reveal").forEach((element) => {
                element.classList.add("is-visible");
              });
            }, reducedMotion.matches ? 0 : 320);
          });
        });
      }

      function formatCount(value) {
        return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(value);
      }

      function getCountStart(target) {
        const offset = Math.min(Math.max(Math.round(target * 0.24), 24), 120);
        return Math.max(0, target - offset);
      }

      function animateCount(element) {
        const target = Number.parseInt(
          element.dataset.countTarget || element.textContent.replace(/[^\d]/g, ""),
          10
        );

        if (!Number.isFinite(target)) {
          return;
        }

        const start = getCountStart(target);
        const duration = reducedMotion.matches ? 1 : 4000;
        const startedAt = performance.now();

        function tick() {
          const now = performance.now();
          const progress = Math.min((now - startedAt) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const current = Math.round(start + (target - start) * eased);

          element.textContent = formatCount(current);

          if (progress < 1) {
            window.setTimeout(tick, 33);
          }
        }

        element.textContent = formatCount(start);
        window.setTimeout(tick, 33);
      }

      function initCountUps() {
        const countUpElements = Array.from(document.querySelectorAll("[data-count-up]"));

        countUpElements.forEach((element) => {
          if (element.dataset.countStarted === "true") {
            return;
          }

          element.dataset.countStarted = "true";
          animateCount(element);
        });
      }

      function getWidget(form) {
        return form.closest("[data-lead-widget]");
      }

      function setInvalid(form) {
        const input = form.querySelector("input[type='email']");

        if (!input) {
          return;
        }

        form.classList.add("is-invalid");
        input.setAttribute("aria-invalid", "true");
      }

      function clearInvalid(form) {
        const input = form.querySelector("input[type='email']");

        form.classList.remove("is-invalid");

        if (input) {
          input.removeAttribute("aria-invalid");
        }
      }

      function showSuccessEverywhere(forms) {
        forms.forEach((form) => {
          const widget = getWidget(form);
          const success = widget && widget.querySelector("[data-lead-success]");
          const button = form.querySelector("button");

          clearInvalid(form);

          if (widget) {
            widget.classList.add("is-success");
          }

          form.hidden = true;

          if (button) {
            button.disabled = true;
          }

          if (success) {
            success.hidden = false;
          }
        });
      }

      function trackLead(action, form, extra) {
        if (!window.LmLeadTrack) {
          return;
        }
        window.LmLeadTrack.track(action, form, getWidget(form), extra);
      }

      async function submitShopifyCustomerForm(form) {
        const response = await fetch(form.action, {
          method: "POST",
          body: new FormData(form),
          credentials: "same-origin",
          headers: {
            Accept: "text/html"
          }
        });

        if (!response.ok) {
          throw new Error("Shopify customer form request failed.");
        }
      }

      function isShopifyCustomerForm(form) {
        return Boolean(form.querySelector("input[name='form_type'][value='customer']"));
      }

      function initEmailForm() {
        const forms = Array.from(document.querySelectorAll("[data-lm-lead-widget] .lm-lead-form"));

        forms.forEach((form) => {
          const input = form.querySelector("input[type='email']");

          if (!input) {
            return;
          }

          input.addEventListener("input", () => {
            if (form.classList.contains("is-invalid")) {
              clearInvalid(form);
            }
          });

          form.addEventListener("submit", async (event) => {
            event.preventDefault();

            const value = input.value.trim();
            const button = form.querySelector("button");

            if (!emailPattern.test(value)) {
              setInvalid(form);
              trackLead("error", form, { lm_lead_error_type: "invalid_email" });
              input.focus();
              return;
            }

            trackLead("submit", form);

            if (!isShopifyCustomerForm(form)) {
              trackLead("success", form);
              showSuccessEverywhere(forms);
              return;
            }

            if (button) {
              button.disabled = true;
            }

            try {
              await submitShopifyCustomerForm(form);
              trackLead("success", form);
              showSuccessEverywhere(forms);
            } catch (error) {
              if (button) {
                button.disabled = false;
              }
              setInvalid(form);
              trackLead("error", form, { lm_lead_error_type: "request_failed" });
              input.focus();
            }
          });
        });
      }

      initReveal();
      initAnchorScroll();
      initCountUps();
      initEmailForm();
    })();

